import axios from 'axios';
import { getToken } from '@/utils/auth';
import { Message } from 'element-ui';

// 默认接口地址
axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? '' : '';

// request interceptor
axios.interceptors.request.use(
    config => {
        if (config.url.indexOf('/woauth2/oauth/token') !== -1) {
            config.headers['Authorization'] = 'Basic Y2xpOnNlYw==';
        } else if (getToken()) {
            config.headers['Authorization'] = 'Bearer ' + getToken() + '';
        }
        return config;
    },
    error => {
        Promise.reject(error);
    }
);

// 响应拦截器
axios.interceptors.response.use(
    res => {
        let data = res.data;
        const { state, subMsg, responseCode } = data;
        if (data.access_token || responseCode === 0) {
        } else {
            if (state !== 200 && state !== 4061 && state !== 406) {
                if (subMsg) {
                    Message.error(`错误：${subMsg}`);
                }
            }
        }
        return data;
    },
    err => {
        if (err.response) {
            switch (err.response.status) {
                case 404:
                    Message.error(`错误：404，找不到网络资源`);
                    break;
                case 500:
                    Message.error(`错误：500，服务器出错`);
                    break;
                case 503:
                    Message.error(`错误：${err}`);
                    break;
                case 521:
                    Message.error(`错误：${err.response.data.msg || ''}`);
                    break;
            }
        }
        return Promise.reject(err);
    }
);

export default function _axios(method, url, params, specialurl) {
    ///ms-doctor/v2/delete_role/roles/${roleId}/iuid/${iuId}
    //specialurl 部分接口因为传参在url中 无法匹配 所以通过 specialurl 字段判断
    let newurl = '';
    let href = window.location.href;
    //2021-08-10 后端接口迁移 部分接口需要替换新的测试或生产域名
    let baseURL =
        href.indexOf('localhost') != -1 ? '/test' : href.indexOf('shulan-hospital.shulan.com') != -1 ? 'https://sho-api.shulan.com' : 'https://shoapi-lan.shulan.com:8443'; //正式放开
    // let baseURL = '/test'; //本地启动项目 /test 代理接口对应域名
    let newurlList = [
        '/ms-shulan-hospital/v1/backstage',
        '/ms-shulan-hospital/v1/doctor',
        '/ms-shulan-hospital/v1/doctorApply',
        '/oauth/verification/code/send/by/staffNo',
        '/oauth/dynamic/password/code/send',
        '/oauth/token/post'
    ]; //需要单独配置域名的接口
    newurlList.forEach(item => {
        if (item == url || specialurl == 'specialurl') {
            newurl = baseURL + url;
        }
    });
    console.log(newurl, 'newurl');
    method = method.toUpperCase();
    let options = {
        method: method,
        url: newurl ? newurl : url,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    };

    if (method === 'POST' || method === 'PATCH' || method === 'PUT') {
        if (params) {
            options.data = params;
        }
    }

    if (method === 'GET' || method === 'DELETE') {
        if (params) {
            options.params = params;
        }
    }

    return axios(options).then(
        res => {
            return res;
        },
        error => {
            return error;
        }
    );
}
